import { D1EventForm } from "./form";

export function D1EventsNew() {
  return <D1EventForm isNew />;
}
